/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2636__part-181
 */

"use strict"

var hj
var fj
import * as /* [auto-meaningful-name] */Src_shared_ui_components_Dialog_index from /* 540 */"../../../../src/shared/ui/components/Dialog/index"
!function (e) {
  e[e.Image = 1] = "Image"
  e[e.Icon = 2] = "Icon"
  e[e.Sound = 3] = "Sound"
}(fj || (fj = {}));
(function (e) {
  e[e.Mall = 1] = "Mall"
  e[e.Library = 2] = "Library"
})(hj || (hj = {}))
export { fj }
export { hj }
